import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { createReducer, on, Action } from "@ngrx/store";
import { NoticeEntityJson } from "@youm-front/notice/domain";
import { NoticeActions } from "../actions";

export const NOTICE_FEATURE_KEY = "notice";

export interface NoticeState extends EntityState<NoticeEntityJson> {}

export const noticeAdapter: EntityAdapter<NoticeEntityJson> =
  createEntityAdapter<NoticeEntityJson>({
    selectId: (_) => _.id,
    sortComparer: (lhs, rhs) => {
      return rhs.createdAt - lhs.createdAt;
    }
  });

export const initialNoticeState: NoticeState = noticeAdapter.getInitialState(
  {}
);

const reducer = createReducer(
  initialNoticeState,
  on(NoticeActions.noticeCreate, (state, { noticeCreateCmd }) =>
    noticeAdapter.addOne(noticeCreateCmd.toJSON(), state)
  ),
  on(
    NoticeActions.noticeDelete,
    (
      state,
      {
        noticeDeleteCmd: {
          value: { id }
        }
      }
    ) => noticeAdapter.removeOne(id, state)
  )
);

export function noticeReducer(state: NoticeState | undefined, action: Action) {
  return reducer(state, action);
}
